<template>

   <div class="pentest-field-group">
      <label for="applicationName" class="form-label">What Mobile App/s is in scope for testing?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <textarea id="applicationName" class="form-control" v-model.trim="application.name" 
         @blur="v$.application.name.$touch" :disabled="disableForm()"></textarea>
      <span class="form-text text-danger error-msg" v-if="v$.application.name.$error">
         Required field.
      </span>
   </div>

   <div class="pentest-field-group">
      <label for="applicationPurpose" class="form-label">What is the purpose of the Mobile App?</label>
      <textarea id="applicationPurpose" class="form-control" 
         v-model.trim="application.purpose" :disabled="disableForm()"></textarea>
   </div>

   <div class="form-control pentest-field-group">
      <label class="form-label">Are there APIs which are also in scope for testing?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>

      <div v-if="isCreate">
         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=true 
               v-model.trim="application.hasApiForTesting" id="hasApi" name="hasApiForTesting"
               :disabled="disableForm()">
            <label class="form-check-label" for="hasApi">Yes</label>
         </div>

         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=false 
               v-model.trim="application.hasApiForTesting" 
               id="noApi" name="hasApiForTesting" @change="onChange()"
               :disabled="disableForm()">
            <label class="form-check-label" for="noApi">No</label>
         </div>
         
      </div>

      <div v-else>
         <input :disabled="disableForm()" type="text" class="form-control" :value="application.hasApiForTesting ? 'Yes' : 'No'" />
      </div>
      
      <div class="mt-2" v-if="application.hasApiForTesting">
         <label for="apiPurpose" class="form-label">What is the purpose of the API/s?</label>
         <textarea id="apiPurpose" class="form-control" 
            v-model.trim="application.apiPurpose" :disabled="disableForm()"></textarea>
      </div>

   </div>

   <div v-if="isCreate && application.hasApiForTesting">
      <label for="apiRelevantFiles" class="form-label">Please provide a list, count or swagger file of the API/s.</label>
      <FileUploader ref="apiRelevantFiles" :id="'apiRelevantFiles'" @fileListChange="handleFileUpload"
         key="apiRelevantFiles"/>
   </div>


   <div class="pentest-field-group">
      <label for="operatingSystem" class="form-label">Which Operating System is used?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>

      <div v-if="isCreate">

         <VueMultiselect id="operatingSystem" v-model="application.operatingSystem" 
            @blur="v$.application.operatingSystem.$touch"
            :options="operatingSystemList" :multiple="true" 
            :close-on-select="true" label="name" track-by="value" :searchable="false"
            placeholder="Please choose at least one..." :disabled="disableForm()">
         </VueMultiselect>

         <span class="form-text text-danger error-msg" v-if="v$.application.operatingSystem.$error">
            Please choose at least one.
         </span>
      </div>

      <div v-else>
         <input type="text" class="form-control" 
            :disabled="disableForm()"
            :value="application.operatingSystem.map(os=>os.name).toString().replace(',', ', ')"/>
      </div>
      
   </div>

   <div v-if="application.isAndroid" class="form-control pentest-field-group">
      <label class="form-label">Is the app available on the Android Playstore?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>

      <div v-if="isCreate">
         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=true 
               v-model.trim="application.isAvailableOnPlaystore" id="isOnAndroidPlaystore" name="isOnAndroidPlaystore"
               :disabled="disableForm()">
            <label class="form-check-label" for="isOnAndroidPlaystore">Yes</label>
         </div>

         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=false 
               v-model.trim="application.isAvailableOnPlaystore" 
               id="notOnAndroidPlaystore" name="isOnAndroidPlaystore" @change="onChange()"
               :disabled="disableForm()">
            <label class="form-check-label" for="notOnAndroidPlaystore">No</label>
         </div>
      </div>

      <div v-else>
         <input :disabled="disableForm()" type="text" class="form-control" :value="application.isAvailableOnPlaystore ? 'Yes' : 'No'">
      </div>

      <div class="mt-2" v-if="application.isAvailableOnPlaystore">
         <label for="playstoreUrl" class="form-label">Please provide the Playstore URL.
            <span v-if="isCreate" class="requiredField">*</span>
         </label>
         <textarea id="playstoreUrl" class="form-control" v-model.trim="application.playstoreUrl" 
            @blur="v$.application.playstoreUrl.$touch" :disabled="disableForm()"></textarea>
         <span class="form-text text-danger error-msg" v-if="v$.application.playstoreUrl.$error">
            Required field.
         </span>
      </div>

   </div>

   <div v-if="application.isIos" class="form-control pentest-field-group">
      <label class="form-label">Is the app available on the Apple App Store?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>

      <div v-if="isCreate">
         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=true 
               v-model.trim="application.isAvailableOnAppleAppStore" id="isOnAndroidPlaystore" name="isOnAppleAppStore"
               :disabled="disableForm()">
            <label class="form-check-label" for="isOnAppleAppStore">Yes</label>
         </div>

         <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" :value=false 
               v-model.trim="application.isAvailableOnAppleAppStore" 
               id="notOnAppleAppStore" name="isOnAppleAppStore" @change="onChange()"
               :disabled="disableForm()">
            <label class="form-check-label" for="notOnAppleAppStore">No</label>
         </div>

      </div>

      <div v-else>
         <input :disabled="disableForm()" type="text" class="form-control" :value="application.isAvailableOnAppleAppStore ? 'Yes' : 'No'">
      </div>

      <div class="mt-2" v-if="application.isAvailableOnAppleAppStore">
         <label for="appleStoreUrl" class="form-label">Please provide the Apple App Store URL.
            <span v-if="isCreate" class="requiredField">*</span>
         </label>
         <textarea id="appleStoreUrl" class="form-control" v-model.trim="application.appleAppStoreUrl" 
            @blur="v$.application.appleAppStoreUrl.$touch" :disabled="disableForm()"></textarea>
         <span class="form-text text-danger error-msg" v-if="v$.application.appleAppStoreUrl.$error">
            Required field.
         </span>
      </div>

   </div>

   <div v-if="application.isIos" class="form-control pentest-field-group">
      <label class="form-label">Will this be an authenticated test with logins provided?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <div v-if="isCreate">
         <p class="text-muted">Authenticated tests generally provide more comprehensive and valuable results as it enables us to test for vulnerabilities outside and inside the application.</p>
         
         <div>
            <div class="form-check form-check-inline">
               <input class="form-check-input" type="radio" :value=true 
                  v-model.trim="application.isAuthenticated" id="isAuthenticated" name="isAuthenticatedApp" :disabled="disableForm()">
               <label class="form-check-label" for="isAuthenticated">Yes</label>
            </div>

            <div class="form-check form-check-inline">
               <input class="form-check-input" type="radio" :value=false 
                  v-model.trim="application.isAuthenticated" id="notAuthenticated" name="isAuthenticatedApp"
                  :disabled="disableForm()">
               <label class="form-check-label" for="notAuthenticated">No</label>
            </div>

         </div>
      </div>

      <div v-else>
         <input type="text" class="form-control" id="isAuthenticated" 
            :disabled="disableForm()"
            :value="application.isAuthenticated ? 'Yes' : 'No'"/>
      </div>

   </div>

   <div v-if="isCreate">
      <label for="appRelevantFiles" class="form-label">Please provide any additional relevant files including screenshots or lists of Mobile App pages.</label>
      <FileUploader ref="appRelevantFiles" :id="'appRelevantFiles'" @fileListChange="handleFileUpload"
            key="appRelevantFiles"/>
   </div>

   <!-- files list -->
   <div class="pentest-field-group pentest-files-list" v-if="isView && application.relevantFiles">
      <div class="mb-2 align-items-center">
         <strong>Files provided:</strong>
         <a href="#" class="m-2 small" v-if="application.relevantFiles.length > 1 && !isDownloadingAllFiles"
            @click="downloadAllFiles('MobileApp', this.testTypeId)"
            title="Click to download all available files" style="color:gray">
            <i class="fa-solid fa-download pe-1"></i>
            <span>Download all files</span>
         </a>
            
         <span class="m-2 small" v-if="isDownloadingAllFiles" :class="{'d-none' : !isDownloadingAllFiles}" style="color:gray">
            <span class="spinner-border spinner-border-sm" role="status">
               <span class="visually-hidden">Downloading files...</span>
            </span>

            <span class="m-2">Downloading files...</span>
         </span>
      </div>
      
      <ul class="pb-2">
         <li v-for="file in application.relevantFiles" :key="file.id">

            <div class="file-wrapper">
               <div class="pb-3 file-icon">
                  <img :src="require('@/assets/img/file_type_icons/'+getFileTypeIcon(file.file_extension))" alt="File Icon"/>
               </div>

               <span class="file-download-icon" title="Click to download file" @click="downloadFile('MobileApp', file)">
                  <i class="fa-regular fa-circle-down"></i>
               </span>
               
               <div class="pt-3 file-name" :title="file.file_name">{{ file.file_name}}</div>
            </div>

            <span :id="file.id" :ref="file.id" class="loading d-none">
               <span class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Downloading file...</span>
               </span>
            </span>
         </li>

      </ul>
      
      
   </div>
   <!-- end -- files list -->


</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import { getFileTypeIcon } from '@/plugins/helper.js'
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import FileUploader from '@/components/FileUploader.vue';

export default({

   components: {
      VueMultiselect,
      FileUploader
   },
   
   setup () {
      return { v$: useVuelidate() }
   },

   emits: ['downloadFile', 'downloadAllFiles'],

   props: {
      items: {
         type: Object,
      },

      action: {
         type: String,
      },
      
   },

   data(){
      return {
         application: {
            name: '',
            purpose: '',
            hasApiForTesting: false,
            apiPurpose: '',
            apiRelevantFiles: [],
            operatingSystem: [],
            isAndroid: false,
            isAvailableOnPlaystore: false,
            playstoreUrl: '',
            isIos: false,
            isAvailableOnAppleAppStore: false,
            appleAppStoreUrl: '',
            isAuthenticated: false,
            relevantFiles: [],
         },
         operatingSystemList:[
            {name: "Android", value: "android"},
            {name: "iOS", value: "ios"}
         ],
         testTypeId: '',
         isView: false,
         isCreate: false,
         isDownloadingAllFiles: false,
      }
      
   }, 

   validations() {
      return {
         application: {
            name: { required },
            hasApiForTesting: { required },
            operatingSystem: { required },
            isAvailableOnPlaystore: { requiredIf: requiredIf(this.application.isAndroid) },
            playstoreUrl: { requiredIf: requiredIf(this.application.isAvailableOnPlaystore) },
            isAvailableOnAppleAppStore: { requiredIf: requiredIf(this.application.isIos) },
            appleAppStoreUrl: { requiredIf: requiredIf(this.application.isAvailableOnAppleAppStore)  },
            isAuthenticated: { required },
         },
         
      }
   },

   computed: {
      itemList(){
         return this.items
      },

      selectedOperatingSystem(){
         return this.application.operatingSystem
      },

      isAndroid() {
         return this.application.isAndroid
      },

      isIos() {
         return this.application.isIos
      },

   },

   watch: {
      itemList(){
         this.init()
      },

      selectedOperatingSystem(){

         let data = this.application.operatingSystem

         this.application.isAndroid = false
         this.application.isIos = false
         
         if (data.length > 0){
            this.application.isAndroid = data.map(e => (e.value)).includes("android")

            this.application.isIos = data.map(e => (e.value)).includes("ios")
         }

      },

      isAndroid() {
         this.v$.application.playstoreUrl.$reset()
         
         if (!this.application.isAndroid){
            this.application.isAvailableOnPlaystore = false
            this.application.playstoreUrl = ''
         }
         
      },

      isIos() {
         this.v$.application.appleAppStoreUrl.$reset()

         if (!this.application.isIos){
            this.application.isAvailableOnAppleAppStore = false
            this.application.appleAppStoreUrl = ''
         }
      },

   },

   created(){
      this.init()
   },

   methods: {
      init(){

         if (this.action == 'create') {
            this.createForm()
         } else {
            this.viewForm()
            this.testTypeId = this.items.test_type
            this.application.operatingSystem = []
            this.application.name = this.items.app.app_name
            this.application.purpose = this.items.app.app_purpose
            this.application.hasApiForTesting = this.items.app.app_has_api_for_testing
            this.application.apiPurpose = this.items.app.app_api_purpose
            this.application.apiRelevantFiles = this.items.app.api_relevant_files
            this.application.isAndroid = this.items.app.app_is_android
            this.application.isAvailableOnPlaystore = this.items.app.app_is_available_on_android_playstore
            this.application.playstoreUrl = this.items.app.app_playstore_url
            this.application.isIos = this.items.app.app_is_ios
            this.application.isAvailableOnAppleAppStore = this.items.app.app_is_available_on_apple_app_store
            this.application.appleAppStoreUrl = this.items.app.app_apple_app_store_url
            this.application.isAuthenticated = this.items.app.app_is_authenticated
            this.application.relevantFiles = this.items.app.relevant_files

            if (this.application.isAndroid) {
               this.application.operatingSystem.push({
                  name: "Android", value: "android"
               })
            }

            if (this.application.isIos) {
               this.application.operatingSystem.push({
                  name: "iOS", value: "ios"
               })
            }
         }

      },

      createForm(){
         this.isCreate = true
         this.isView = false
      },

      viewForm(){
         this.isCreate = false
         this.isView = true
      },

      resetForm(){
         this.v$.application.$reset()
      
         this.testTypeId = ''
         this.application.name = ''
         this.application.purpose = ''
         this.application.hasApiForTesting = false
         this.application.apiPurpose = ''
         this.application.apiRelevantFiles = []
         this.application.operatingSystem = []
         this.application.isAndroid = false
         this.application.isAvailableOnPlaystore = false
         this.application.playstoreUrl = ''
         this.application.isIos = false
         this.application.isAvailableOnAppleAppStore = false
         this.application.appleAppStoreUrl = ''
         this.application.isAuthenticated = false
         this.application.relevantFiles = []
      },

      // reset some inputs that are dependent on radio button value
      onChange() {
         // APP
         if (!this.application.hasApiForTesting) {
            this.application.apiPurpose = ''
         }

         if (!this.application.isAvailableOnPlaystore) {
            this.application.playstoreUrl = ''
            this.v$.application.playstoreUrl.$reset()
         }

         if (!this.application.isAvailableOnAppleAppStore) {
            this.application.appleAppStoreUrl = ''
            this.v$.application.appleAppStoreUrl.$reset()
         }
      },

      getAppPenTestDetails(){
         let app = {
               app_name : this.application.name,
               app_purpose : this.application.purpose,
               app_has_api_for_testing : this.application.hasApiForTesting,
               app_api_purpose : this.application.apiPurpose,
               app_is_android : this.application.isAndroid,
               app_is_available_on_android_playstore : this.application.isAvailableOnPlaystore,
               app_playstore_url : this.application.playstoreUrl,
               app_is_ios : this.application.isIos,
               app_is_available_on_apple_app_store : this.application.isAvailableOnAppleAppStore,
               app_apple_app_store_url : this.application.appleAppStoreUrl,
               app_is_authenticated : this.application.isAuthenticated,
            }

            app.api_relevant_files = []
            this.application.apiRelevantFiles.forEach((s) => {
               app.api_relevant_files.push({ 
                  encoded_file : s.encoded,
                  file_extension: s.extension
               })
            })

            app.relevant_files = []
            this.application.relevantFiles.forEach((s) => {
               app.relevant_files.push({ 
                  encoded_file : s.encoded,
                  file_extension: s.extension
               })
            })

         return app

      },

      getFileTypeIcon(type){
         return getFileTypeIcon(type)
      },

      handleFileUpload({type, files}) {

         if (type == "appRelevantFiles") {
            this.application.relevantFiles = files
         } else if (type == "apiRelevantFiles") {
            this.application.apiRelevantFiles = files
         }
      },

      disableForm(){
         return this.isView
      },

      downloadFile(testType, file){
         //show loading icon
         this.$refs[file.id][0].classList.remove('d-none')
         this.$emit('downloadFile', {testType : testType, file: file})
      },

      downloadAllFiles(testType, testTypeId){
         this.isDownloadingAllFiles = true
         this.$emit('downloadAllFiles', {testType : testType, testTypeId : testTypeId})
      },

      downloadFileDone(fileId) {
         //remove loading icon
         this.$refs[fileId][0].classList.add('d-none')
      },

      downloadAllFilesDone() {
         this.isDownloadingAllFiles = false
      },
   }
})
</script>
